(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/init-store.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/init-store.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _window$RTKQ = window.RTKQ,
  createApi = _window$RTKQ.createApi,
  fetchBaseQuery = _window$RTKQ.fetchBaseQuery;
const jupiterFetch = svs.core.jupiterFetch;
const getOmsKey = svs.grassroots.utils.omsKey.getOmsKey;
const grassrootsQueryApi = createApi({
  reducerPath: 'grassrootsQuery',
  baseQuery: fetchBaseQuery({
    baseUrl: "".concat(jupiterFetch.url()),
    fetchFn: jupiterFetch.fetch
  }),
  endpoints: builder => ({
    fetchReceiversSearch: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        var _arg$numResponses;
        if (!(arg !== null && arg !== void 0 && arg.searchterm)) {
          return {
            data: {
              receivers: [],
              numberfound: 0
            }
          };
        }
        const numResponses = Math.min(50, (_arg$numResponses = arg === null || arg === void 0 ? void 0 : arg.numResponses) !== null && _arg$numResponses !== void 0 ? _arg$numResponses : 5);
        const searchReceiversFetch = await fetchWithBQ({
          url: '/player/2/sponsorship/search',
          params: {
            search: arg.searchterm,
            numResponses,
            offset: 0
          }
        });
        if (searchReceiversFetch.error) {
          return {
            error: searchReceiversFetch.error
          };
        }
        return {
          data: {
            receivers: searchReceiversFetch.data.receivers,
            numberfound: searchReceiversFetch.data.numberfound
          }
        };
      },
      transformResponse: (response, meta) => ({
        data: response,
        numberfound: meta.numberfound
      })
    }),
    fetchReceiverById: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        if (!arg) {
          return {
            data: null
          };
        }
        const searchReceiversFetch = await fetchWithBQ({
          url: '/player/2/sponsorship/receiverinfo',
          params: {
            receiver: arg
          }
        });
        if (searchReceiversFetch.error) {
          return {
            error: searchReceiversFetch.error
          };
        }
        return {
          data: searchReceiversFetch.data.receiver
        };
      }
    }),
    fetchReceiverSelection: builder.query({
      query: () => ({
        url: '/player/2/sponsorship/receiverselection',
        params: {
          active: true
        }
      }),
      transformResponse: response => response.receivers
    }),
    setReceiverSelection: builder.mutation({
      query: id => ({
        url: '/player/1/sponsorship/receiverselection',
        method: 'POST',
        body: {
          receivers: [id],
          omsKey: getOmsKey()
        }
      })
    }),
    removeReceiverSelection: builder.mutation({
      query: id => ({
        url: '/player/1/sponsorship/receiverselection',
        method: 'DELETE',
        body: {
          receivers: [id],
          includeStatisticsInReply: true,
          omsKey: getOmsKey()
        }
      })
    }),
    replaceReceiverSelection: builder.mutation({
      query: body => ({
        url: '/player/1/sponsorship/receiverselection',
        method: 'PUT',
        body: _objectSpread(_objectSpread({}, body), {}, {
          includeStatisticsInReply: true,
          omsKey: getOmsKey()
        })
      })
    }),
    fetchStatistics: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const statisticsFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/statistics'
        });
        if (statisticsFetch.error) {
          return {
            error: statisticsFetch.error
          };
        }
        return {
          data: statisticsFetch.data
        };
      }
    }),
    fetchResultCountry: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        if (arg !== '') {
          const countryFetch = await fetchWithBQ({
            url: '/player/1/sponsorship/statistics/country',
            params: {
              year: arg
            }
          });
          if (countryFetch.error) {
            return {
              error: countryFetch.error
            };
          }
          return {
            data: countryFetch.data
          };
        }
        return {
          data: null
        };
      }
    }),
    fetchResultProvince: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        if (arg.length === 2) {
          const provinceFetch = await fetchWithBQ({
            url: '/player/1/sponsorship/statistics/province',
            params: {
              year: arg[0],
              province: arg[1]
            }
          });
          if (provinceFetch.error) {
            return {
              error: provinceFetch.error
            };
          }
          return {
            data: provinceFetch.data
          };
        }
        return {
          data: null
        };
      }
    }),
    fetchResultSport: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const sportFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/statistics/sport',
          params: {
            sport: arg
          }
        });
        if (sportFetch.error) {
          return {
            error: sportFetch.error
          };
        }
        return {
          data: sportFetch.data
        };
      }
    }),
    fetchResultProvinceAndSports: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const fetch = await fetchWithBQ({
          url: '/player/1/sponsorship/statistics/values'
        });
        if (fetch.error) {
          return {
            error: fetch.error
          };
        }
        return {
          data: fetch.data
        };
      }
    })
  })
});
const MOST_SUPPORTERS = 1;
const MOST_POINTS = 2;
svs.grassroots.store = {
  grassrootsQueryApi,
  MOST_SUPPORTERS,
  MOST_POINTS
};

 })(window);